module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av660-ae0d14770c42d246171c296c8510e72f.jpg";